<template>
    <div class="home">
        <b-container fluid>
            <b-row>
              <b-col>
                <h1>Information Change Review</h1>
              </b-col>
            </b-row>

            <div class="card">
                <div class="card-header">Review</div>
                <div class="card-body">
                    <b-row>
                        <b-col cols="4"><BaseTextOutput label="Current Assignee" :value="change.assignedName"/></b-col>
                        <b-col cols="4"><BaseTextOutput label="Assigned Date" :value="change.assignedDate"/></b-col>
                        <b-col cols="4" v-if="!isAssigned"><b-button variant="success" class="mr-4" @click="reassign">Assign To Me</b-button></b-col>
                    </b-row>
                  <b-row>
                    <b-col cols="3"><BaseTextOutput label="CNA Last Name" :value="profile.lastName"/></b-col>
                    <b-col cols="3"><BaseTextOutput label="CNA First Name" :value="profile.firstName"/></b-col>
                    <b-col cols="3"><BaseTextOutput label="CNA SSN" :value="profile.ssn"/></b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <BaseTextOutput label="Request Type" :value="this.type==='ssn'?'Social Security Number Change':this.type==='name'?'Name Change':this.type==='dob'?'Date Of Birth Change':'Unknown'"/>
                    </b-col>
                  </b-row>
                    <div v-if="this.type === 'name'">
                        <b-row>
                            <b-col cols="4"><BaseTextOutput label="Current Last Name" :value="profile.lastName"/></b-col>
                            <b-col cols="4"><BaseTextOutput label="Current First Name" :value="profile.firstName"/></b-col>
                            <b-col cols="4"><BaseTextOutput label="Current Middle Name" :value="profile.middleName"/></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="4"><BaseTextOutput :label="(change.status==='Approved'?'Former':'Updated') +' Last Name'" :value="change.lastName"/></b-col>
                            <b-col cols="4"><BaseTextOutput :label="(change.status==='Approved'?'Former':'Updated') + ' First Name'" :value="change.firstName"/></b-col>
                            <b-col cols="4"><BaseTextOutput :label="(change.status==='Approved'?'Former':'Updated') + ' Middle Name'" :value="change.middleName"/></b-col>
                        </b-row>
                    </div>
                    <div v-if="this.type === 'ssn'">
                        <b-row>
                            <b-col cols="4"><BaseTextOutput label="Current SSN" :value="profile.ssn"/></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="4"><BaseTextOutput :label="(change.status==='Approved'?'Former':'Updated') +' SSN'" :value="change.ssn"/></b-col>
                        </b-row>
                    </div>
                  <div v-if="this.type === 'dob'">
                    <b-row>
                      <b-col cols="4">
                        <BaseTextOutput label="Current DOB" :value="profile.dateOfBirth"/>
                      </b-col>
                      <b-col cols="4">
                        <BaseTextOutput :label="(change.status==='Approved'?'Former':'Updated') +' DOB'" :value="change.dateOfBirth"/>
                      </b-col>
                    </b-row>
                    <b-row class="mt-2">
                      <b-col>
                        <div v-if="change.headmaster" class="font-weight-bold">
                            Change submitted via Headmaster
                        </div>
                      </b-col>
                    </b-row>
                  </div>

                    <h2 class="mt-4">Attachments</h2>
                    <AttachmentList :value="attachments" :type="type"/>

                    <b-row class="mt-1" v-if="isReceived && isAssigned">
                        <b-col cols="12">
                            <b-button variant="success" class="mr-4" @click="showApproveModal">Approve Change</b-button>
                            <b-button variant="danger" class="mr-2" @click="showDenyModal">Deny Change</b-button>
                        </b-col>
                    </b-row>
              </div>
            </div>

        </b-container>

        <b-modal id="approve-modal" hide-header hide-footer>
            <h2>Approve Change</h2>
            <hr/>
            <form ref="form" @submit.prevent="approve">
                You are about to approve the {{type}} change from user {{profile.firstName}} {{profile.lastName}}.
                <p class="mt-2">Press Confirm to approve or Cancel to return to the application review.</p>
                <div>
                    <b-button @click="closeApproveModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
                    <b-button type="submit" variant="primary">Confirm</b-button>
                </div>
            </form>
        </b-modal>
        <b-modal id="deny-modal" hide-header hide-footer>
            <h2>Deny Change</h2>
            <hr/>
            <form ref="form" @submit.prevent="deny">
                You are about to deny the {{type}} change from user {{profile.firstName}} {{profile.lastName}}.
                <p class="mt-2">Press Confirm to deny or Cancel to return to the application review.</p>
                <div>
                    <b-button @click="closeDenyModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
                    <b-button type="submit" variant="primary">Confirm</b-button>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
import axios from 'axios'
import AttachmentList from '@/components/templates/display/AttachmentList.vue'
import {toastService} from "@/mixins/toastService"
import BaseTextOutput from "../../components/templates/input/BaseTextOutput.vue";

export default {
    components: {
      BaseTextOutput,
        AttachmentList
    },

    data: () => ({
        type: null,
        profile: {},
        change: {},
        attachments: []
    }),

    mounted() {
        this.type = this.$route.params.type
        this.loadProfile()
        this.loadChange()
    },

    methods: {
        loadProfile() {
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/profile/${this.$route.params.uuid}`)
                .then(response => {
                    this.profile = response.data
                })
        },
        loadChange() {
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/change/${this.type}/${this.$route.params.id}`)
                .then(response => {
                    this.change = response.data
                    this.attachments.push(this.change.attachment)
                })
        },
        showApproveModal() {
            this.$bvModal.show('approve-modal')
        },
        closeApproveModal() {
            this.$bvModal.hide('approve-modal')
        },
        showDenyModal() {
            this.$bvModal.show('deny-modal')
        },
        closeDenyModal() {
            this.$bvModal.hide('deny-modal')
        },
        approve() {
            this.submitToServer('approve')
        },
        deny() {
            this.submitToServer('deny')
        },
        submitToServer(action) {
          axios.post(`${process.env.VUE_APP_API_BASE_URL}/change/${this.type}/${action}`, this.$route.params.id)
            .then(response => {
               toastService.showRootToast("Updated", "Your decision has been updated.", "success", this.$root)
               this.$router.push('/home')
          }).catch(error => {
              toastService.showRootToast("Error", "An error has occurred while processing your request", "danger", this.$root)
          })
        },
        reassign() {
            let payload = {
                id: this.change.id,
                assignedName: this.$keycloak.subject,
                type: this.change.assignType.code
            }
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/assign`, payload)
                .then(response => {
                    this.loadChange()
                    toastService.showRootToast("Assigned", "Credentialer has been assigned.", "success", this.$root)
                }) .catch(error => {
                toastService.showRootToast("Error", "An error has occurred " , "danger", this.$root)
            })
        }
    },
    mixins: [
        toastService
    ],
    created() {
        document.title = "Information Change Review - NAR"
    },
    computed: {
        isReceived() {
            return this.change.status === 'Received'
        },
        isAssigned() {
            return this.$keycloak.authenticated && this.$keycloak.subject === this.change.assigned
        },
    }
}
</script>

<style>
</style>